import {Utils, ArgValidator} from 'neo-common';
import {GameModuleResponse} from './GameModuleResponse';

export class GameModuleResponseFactory {
    private static registrations = {};

    /**
     * @function registerModuleResponse - registers module response implementation type.
     * @param moduleResponseType - type of module response implementation.
     * @summary This function MUST be called for each module response which can be found
     * in "modules" property in "ResponseBase" class.
     */
    public static register(moduleResponseType: any): void {
        ArgValidator.ensureIsNotNullOrUndefined(moduleResponseType, 'moduleResponseType');

        var temp = new moduleResponseType() as GameModuleResponse;
        var moduleName = temp.moduleName();

        ArgValidator.ensureStringIsNotNullOrEmpty(moduleName, 'moduleName');

        var reg = GameModuleResponseFactory.registrations[moduleName];
        if (Utils.isNullOrUndefined(reg)) {
            GameModuleResponseFactory.registrations[moduleName] = moduleResponseType;
        }
    }

    public static createModuleResponse<TModuleResponse extends GameModuleResponse>(typeName: string,
        data: any): TModuleResponse {
        var reg: any = GameModuleResponseFactory.registrations[typeName];
        if (Utils.isNullOrUndefined(reg)) {
            throw new Error('Could not found game module response registration for type "' + typeName + '"');
        }

        var result = new reg(data);
        return result as TModuleResponse;
    }
}


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameModuleResponseFactory.ts
 **/